__turbopack_context__.v({
  "language-row": "team-plan-footer-module-scss-module__ROUVCq__language-row",
});
